import React from 'react'
import PropTypes from 'prop-types'

import { Slices } from '../prismic'

/**
 * Product Information. This displays relevant product information as found in the related CMS
 * document.
 *
 * @param {object} params - Component params
 * @returns {function} Component
 */
const ProductSlices = ({ slices, variant }) => (
  <Slices
    slices={
      (slices || [])
        // We'll filter slices to only show ones relevant to the selected variant. If a slice
        // has a whitelist or blacklist then we'll make sure the slice is supposed to be
        // rendered.
        .filter((slice) => {
          try {
            if (!slice.primary || !slice.primary.contextJson) {
              return true
            }
            const context = JSON.parse(slice.primary.contextJson)

            if (Array.isArray(context.whitelist) && context.whitelist.length) {
              return context.whitelist.includes(variant)
            } else if (Array.isArray(context.blacklist) && context.blacklist.length) {
              return !context.blacklist.includes(variant)
            }
          } catch (error) {
            // Failed to parse the contextJson, we'll assume it should be displayed then.
          }

          return true
        })
    }
  />
)

ProductSlices.propTypes = {
  slices: PropTypes.arrayOf(PropTypes.shape({})),
  variant: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

ProductSlices.defaultProps = {
  slices: [],
  variant: undefined,
}

export default ProductSlices
